import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { MenuProps } from './modal/AddAccountUserModal';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Chip from '@material-ui/core/Chip';
import { connect } from 'react-redux';
import { AdminPortalTextField } from './ConsumerAccountProperties';

class AdminPortalDropdown extends Component {
  static propTypes = {
    options: PropTypes.array,
    defaultValue: PropTypes.string,
    label: PropTypes.string,
    id: PropTypes.string,
    disabled: PropTypes.bool.isRequired,
    error: PropTypes.bool,
    isRequired: PropTypes.bool
  }

  defaultProps = {
    options: [],
  };

  selectedChips = (selected) => {
    return <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      <Chip key={selected} label={selected} style={{ marginLeft: 2, marginRight: 2, marginTop: 10 }}/>
    </div>;
  }

  handleChange = (e) => {
    this.props.handleSelectedDropdown(e);
  }

  render() {
    const {
      defaultValue, label, id, error, options, disabled, isRequired, value, menuItems, style,
      helperText
    } = this.props;
    return (
      <div className="display-flex">
        {disabled ?
          <div className="display-flex" style={{ width: '100%', ...style }}>
            <AdminPortalTextField
              error={error}
              id={id}
              color="primary"
              disabled={true}
              label={label}
              value={defaultValue}
              onChange={this.handleChange}
              variant="outlined"
              fullWidth={true}
              required={isRequired}
              helperText={helperText}
            />
          </div>
          :
          <FormControl variant="filled" style={{ width: '100%', paddingRight: 10, ...style }}>
            <InputLabel margin="dense">{isRequired ? `${label} *` : `${label}`}</InputLabel>
            <Select
              multiple={false}
              id={id}
              name={id}
              value={value}
              onChange={this.handleChange}
              input={<OutlinedInput id={`select-multiple-${id}-chip`}/>}
              renderValue={this.selectedChips}
              MenuProps={MenuProps}
            >
              {menuItems || options.map((option) => {
                return <MenuItem key={option} value={option}>{option}</MenuItem>;
              })}
            </Select>
            {isRequired &&
            <FormHelperText
              error={error}>
              This is a required field!
            </FormHelperText>
            }
          </FormControl>
        }
      </div>
    );
  }
}

export default connect()(AdminPortalDropdown);